import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';
import { IconArrowRight } from '@divlab/divanui/icons';

import * as ModalWindows from '@Stores/ModalWindows';
import useTranslation from '@Queries/useTranslation';
import styles from './VideoConsulationBanner.module.css';

import type { FC, HTMLAttributes } from 'react';

const VideoConsulationBanner: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const { className, ...restProps } = props;
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    ModalWindows.open('VideoConsultation');
  }, []);

  return (
    <div {...restProps} className={cn(styles.banner, className)} onClick={handleClick}>
      <div className={styles.title}>
        <div className={styles.left}>
          <div className={styles.icon} />
          {t('video-consultation.title')}
        </div>

        <IconArrowRight className={styles.chevron} />
      </div>
      <div className={styles.text}> {t('video-consultation.description')}</div>
    </div>
  );
};

export default memo(VideoConsulationBanner);
